import type { ClientMediaItem } from '@DigitaleDoerfer/digitale-doerfer-api';

export const MediaItemSize = {
  ORIGINAL: 'original',
  EXTRA_LARGE: 'extraLarge',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  EXTRA_SMALL: 'extraSmall',
  THUMBNAIL: 'thumbnail'
} as const;

export type MediaItemSize = (typeof MediaItemSize)[keyof typeof MediaItemSize];

export type AppMediaItemUrls = Record<MediaItemSize, string>;

export type AppMediaItem =
  | (Omit<ClientMediaItem, 'urls'> & {
      url: string;
    })
  | undefined;
